import type { Config } from '@/config/types.ts';
import { getCurrentMobileRouteContext } from './tenant-route';

const config: Partial<Config> = {
  baseUrl: '/api',
  timeout: 60 * 1000,
  basename: getCurrentMobileRouteContext().basename,
};

export default config;
